
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-[480px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9117ef7a3de43dc416746015fa189d3c.jpg"
          alt="Aerial view of farmland at golden hour"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-950/75 via-emerald-900/50 to-emerald-950/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <nav className="flex items-center gap-2 text-sm text-emerald-200 mb-6">
          <Link to="/" className="hover:text-white transition-colors cursor-pointer">
            Home
          </Link>
          <i className="ri-arrow-right-s-line text-emerald-400"></i>
          <span className="text-white">Contact</span>
        </nav>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-wide max-w-2xl">
          Get In Touch
        </h1>

        <p className="text-xl text-gray-200 max-w-xl leading-relaxed font-light">
          Have a question about our services? Ready to discuss your operation? We&apos;re
          here to help — no pressure, no sales pitch.
        </p>
      </div>
    </section>
  );
}
